export default __webpack_public_path__ + "static/media/성령의 불 기도 mobile.0e7ca79e.jpg";